import { Phone, MessageSquare } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, PHONE_SMS, AVAILABILITY } from "@/lib/content";

export const FooterSection = () => (
  <footer className="bg-[#131519] pt-20 pb-10 text-white">
    <div className="mx-auto max-w-6xl px-5">
      <p
        data-testid="footer-brand"
        className="font-display text-[11vw] font-extrabold leading-none tracking-tight text-white/10 sm:text-7xl lg:text-8xl"
      >
        METRO MOBILE
      </p>
      <div className="mt-14 grid gap-10 border-t border-white/10 pt-12 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="font-mono-alt text-[10px] font-semibold tracking-[0.25em] text-[#9CA3AF]">CALL OR TEXT</p>
          <a
            data-testid="footer-call-button"
            href={PHONE_TEL}
            className="mt-3 flex items-center gap-2 text-lg font-semibold text-white transition-colors hover:text-[#D97706]"
          >
            <Phone size={16} /> {PHONE_DISPLAY}
          </a>
          <a
            data-testid="footer-text-button"
            href={PHONE_SMS}
            className="mt-2 flex items-center gap-2 text-sm text-[#9CA3AF] transition-colors hover:text-white"
          >
            <MessageSquare size={14} /> Text us anytime
          </a>
        </div>
        <div>
          <p className="font-mono-alt text-[10px] font-semibold tracking-[0.25em] text-[#9CA3AF]">SERVICES</p>
          <p className="mt-3 text-sm text-[#D1D5DB]">Basic Clean — $60</p>
          <p className="mt-1 text-sm text-[#D1D5DB]">Premium Clean — $80</p>
        </div>
        <div data-testid="footer-availability">
          <p className="font-mono-alt text-[10px] font-semibold tracking-[0.25em] text-[#9CA3AF]">AVAILABILITY</p>
          {AVAILABILITY.map((a, i) => (
            <p key={a.days} className={`text-sm text-[#D1D5DB] ${i === 0 ? "mt-3" : "mt-1"}`}>
              {a.days} · {a.hours}
            </p>
          ))}
        </div>
        <div>
          <p className="font-mono-alt text-[10px] font-semibold tracking-[0.25em] text-[#9CA3AF]">PAYMENT</p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-[#9CA3AF]">
            We accept Cash App and cash. Text {PHONE_DISPLAY} to receive our official $Cashtag before sending
            payment.
          </p>
        </div>
      </div>
      <p className="mt-14 text-center text-xs text-[#6B7280]">
        © 2026 Metro Mobile Details · Mobile interior detailing · We come to you
      </p>
    </div>
  </footer>
);
